import { render } from "./SetLanguage.vue?vue&type=template&id=348e2b0f&scoped=true"
import script from "./SetLanguage.vue?vue&type=script&lang=js"
export * from "./SetLanguage.vue?vue&type=script&lang=js"

import "./SetLanguage.vue?vue&type=style&index=0&id=348e2b0f&scoped=true&lang=css"
import "./SetLanguage.vue?vue&type=style&index=1&id=348e2b0f&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348e2b0f"]])

export default __exports__